export const deviceFleetConstants = {
  UPDATE_ALL_DEVICES: 'UPDATE_ALL_DEVICES',
  UPDATE_ALL_COMMISSIONED_DEVICES: 'UPDATE_ALL_COMMISSIONED_DEVICES',
  UPDATE_DEVICE_SERIAL: 'UPDATE_DEVICE_SERIAL',
  UPDATE_ERROR_CODES: 'UPDATE_ERROR_CODES',
  UPDATE_DEVICE_STATE_V2: 'UPDATE_DEVICE_STATE_V2',
};
